import usePresentSelector from "./usePresentSelector";
import { useSelector, useDispatch } from 'react-redux';
import A from './ActionCreators';
import G from './Getters';
import C from './Constants';

export default function useImageLoader(imageIds) {
  const dispatch = useDispatch();
  let imageVersions = useSelector(state => {
    return imageIds.map(imageId => {
      let version = C.DEFAULT_PROCESSED_IMAGE_VERSION;
      if (state.media[imageId]["raw-png"]?.localBlobUrl) {
        version = "raw-png";
      } else if (state.media[imageId].raw?.localBlobUrl) {
        version = "raw";
      }
      return version;
    });
  });
  let fetchStatuses = useSelector(state => {
    return imageIds.map((imageId, i) => {
      let version = imageVersions[i];
      let status = G.getMediaFetchStatus(state, { imageId, version });
      if (status && status !== "none") return status;
      if (process.env.NODE_ENV === 'development') {
        let status = G.getMediaFetchStatus(state, { imageId, version: "raw" });
        if (status && status !== "none") return status;
      }
      return "none";
    });
  });
  let notFetched = imageIds.filter((_, i) => fetchStatuses[i] === "none");
  if (notFetched.length > 0) {
    dispatch(A.fetchImages({
      imageSpecList: notFetched.map((imageId, i) => ({ imageId, version: imageVersions[i] }))
    }));
  }

  return { statuses: fetchStatuses, success: fetchStatuses.every(s => s === "success") };
}
